import axios from "axios";

/*En resumen, este código configura una instancia de Axios con una URL 
base que se obtiene de la variable de entorno REACT_APP_API_URL. Esto 
permite realizar solicitudes HTTP utilizando esta instancia en otras 
partes del código, lo que facilita el mantenimiento y la reutilización 
de la configuración de la API en toda la aplicación.*/

export default axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
